var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55904 10V11.3333M8.22571 7.33333V11.3333M10.8924 4.66667V11.3333M5.42571 14H11.0257C12.1458 14 12.7059 14 13.1337 13.782C13.51 13.5903 13.816 13.2843 14.0077 12.908C14.2257 12.4802 14.2257 11.9201 14.2257 10.8V5.2C14.2257 4.0799 14.2257 3.51984 14.0077 3.09202C13.816 2.71569 13.51 2.40973 13.1337 2.21799C12.7059 2 12.1458 2 11.0257 2H5.42571C4.3056 2 3.74555 2 3.31773 2.21799C2.9414 2.40973 2.63544 2.71569 2.44369 3.09202C2.22571 3.51984 2.22571 4.0799 2.22571 5.2V10.8C2.22571 11.9201 2.22571 12.4802 2.44369 12.908C2.63544 13.2843 2.9414 13.5903 3.31773 13.782C3.74555 14 4.3056 14 5.42571 14Z",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.3ef02efe287f37f645c233caa8e742cb.svg";
export { ForwardRef as ReactComponent };